import { __, compose, propOr } from 'ramda';
import { combineReducers } from 'redux';
import { handleAction } from 'redux-actions';

import { propFromPayload } from 'app/reducers/helpers';
import { USER_FETCHED } from 'app/features/user/actionTypes';
import {
  PREMIUM,
  PREMIUM_PLUS,
  FAN,
  SUPER_FAN,
} from 'app/features/user/constants/accessTypes';
import { faq } from 'app/features/success/helpCenterBlock/reducers/organic';

const visibilityByAccessType = {
  [PREMIUM]: true,
  [PREMIUM_PLUS]: true,
  [FAN]: true,
  [SUPER_FAN]: true,
};

const isVisible = handleAction(
  USER_FETCHED,
  compose(
    propOr(false, __, visibilityByAccessType),
    propFromPayload('accessType'),
  ),
  false,
);

const helpCenterBlock = combineReducers({ isVisible, faq });

export default helpCenterBlock;
